import { setFileMode } from '../State/filemode';
import { clearCheckedItemPaths } from '../State/checkedItemPaths';

export default () => async (dispatch) => {
  
  dispatch(setFileMode('grid'));
  dispatch(clearCheckedItemPaths());
  
}